import React from "react";

import {Map, InfoWindow, Marker, GoogleApiWrapper} from 'google-maps-react';
import Geocode from "react-geocode";
import { createBrowserHistory as createHistory } from 'history';

import { SimpleSelect } from '../../components/SimpleSelect'; 

import "./Coverage.scss";

import {
    BrowserRouter as Router,
    Link,
    useParams
  } from "react-router-dom";


const history = createHistory();

var countryData = require('./country.json');
var statesData = require('./states.json');
const GOOGLE_API_KEY = 'AIzaSyC-zp3hc3xiy_p4fgG8lv2mwYKaB1PAMFs';

export class MapContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedPlace : {
                name: 'test'
            }
        };
    }

    onMarkerClick(evt, data) { 
        console.log(evt);
    }
    
    onInfoWindowClose() { }

    render() {

        const markerCordinates = this.props.countryCordinates;
        const selectedCountry = this.props.selectCountry;

        const initialCenter= markerCordinates ? markerCordinates : {lat: 18.109581, lng: -77.297508}
        return (
            <Map google={this.props.google} zoom={14}
            initialCenter={initialCenter}
            >

                { markerCordinates && 

                <Marker onClick={this.onMarkerClick}
                showInfo={true}
                    position={{lat: markerCordinates.lat, lng: markerCordinates.lng}}
                    name={selectedCountry.label} > 
                      
                      <InfoWindow 
                      visible={true}
                     
                      onClose={this.onInfoWindowClose}>
                            <div>
                                <h1>{selectedCountry.label}</h1>
                            </div>
                        </InfoWindow>
                 </Marker>
                }
    

            </Map>
        );
    }
  }



class Coverage extends React.Component {

    positionOptions = {
        enableHighAccuracy: false
    }

    constructor(props) {
        super(props);
        this.state = { 
            isExpanded: false,
            selectCountry: null,
            countryCordinates: null
        };

        this.didClickArea = this.didClickArea.bind(this);
        this.handleMoverOver = this.handleMoverOver.bind(this);
        this.didSelectOption = this.didSelectOption.bind(this);
        this.initGeocode();
    }

    componentDidMount() {
        
       
    }

    initGeocode() {
        Geocode.setApiKey(GOOGLE_API_KEY);
        Geocode.setLanguage('en');
        Geocode.setRegion('es');

        Geocode.setLocationType("ROOFTOP");
        // Enable or disable logs. Its optional.
        Geocode.enableDebug();
        // Get latitude & longitude from address.
        const defaultCountry = countryData[0];
        Geocode.fromAddress(defaultCountry.address).then(
            (response) => {
            const location = response.results[0].geometry.location;
            this.setState({
                countryCordinates: location,
                selectCountry: defaultCountry
             });
            },
            (error) => {
            console.error(error);
            }
        );
    }

    didClickArea(evt) {
        evt.preventDefault();
        const areaId = evt.target.getAttribute('abbrv');
        this.props.history.push('/coverage/' + areaId.toLowerCase() );
    }

    didSelectOption(country) {
        
        if (country) {
            console.log(country);
            // Get latitude & longitude from address.
            Geocode.fromAddress(country.address).then(
                (response) => {
                    const location = response.results[0].geometry.location;
                    this.setState({
                        countryCordinates: location,
                        selectCountry: country
                    });
                },
                (error) => {
                    console.error(error);
                }
            );
        }
    }

    handleMoverOver(evt) {
        if (evt.type === 'mouseenter') {
            this.setState({
                isExpanded: true,
            });
        }else {
            this.setState({
                isExpanded: false
            });
        }
    }

    render() {

        var startIndex  = 1;
        var data = [];
        var tempData =[];

        for (startIndex ; startIndex < statesData.length; startIndex++) {
            if ( startIndex % 5 !== 0  ) {
                tempData.push(statesData[startIndex - 1]);
            }else {
                data.push(tempData);
                tempData = [];
            }
        }

        const optionList = countryData.map((item, i) => {
            return {   
                id: i,
                value: item.abbreviation,
                label: item.name,
                address: item.address
            }
        })
   
        const selectCountry = this.state.selectCountry ? this.state.selectCountry : optionList[0];

        const isHiddenClass = this.state.isExpanded?  "--hide" : '';
        const expandedClass = this.state.isExpanded?  "__expanded" : '';
        const mapProps = {
            ...this.props,
            selectCountry: selectCountry,
            countryCordinates: this.state.countryCordinates

        }
        const MapView =  GoogleApiWrapper({
            apiKey: (GOOGLE_API_KEY)
        })(MapContainer);
      
        return <React.Fragment>
            <div className="map-wrap">
                <MapView className="map-container"  {...mapProps} />
            </div>
            <div className={`select-wrap ${isHiddenClass}`}>
            <SimpleSelect
               
                className="ip-ff-select"
                name="Country"
                title="Select country"
                searchable={["Type name of country."]}
                filterKeys={['label', 'value']}
                list={optionList}
                initialSelected={selectCountry}
                onChange={this.didSelectOption}
                />
            </div>
            <div className={`state-modal ${expandedClass}`} onMouseLeave={this.handleMoverOver} onMouseEnter={this.handleMoverOver} >
                <div className="inner-content">
                    <div className="container">
                        <div className="row">
                            <div className="content">
                                <h2 className="title">Coverage Services by U.S State.</h2>
                                <p className="info">At Virtual Enterprise, we work diligently around the clock 24/7/365 to help our clients succeed. We are a team of smart, personable, off-site receptionists providing companies of all types and sizes throughout the US, Canada, UK and the Caribbean with richer more customized experience.</p>
                                <div className="state-list-cont">
                                    <ul className="state-list">
                                        {
                                            data.map((itemsArray, r)=> {
                                                return (
                                                    <li key={r} className="state-item">
                                                        {itemsArray.map((item, i) => {

                                                            return <div className="col">
                                                                <Link onClick={this.didClickArea} key={i} abbrv={item.abbreviation} href={"#"} className="link-item">
                                                            {item.name}
                                                            </Link>
                                                            </div>
                                                        })}
                                                        
                                                    </li>
                                                );
                                            })
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </React.Fragment>
    }
}

export default Coverage;